import actions from "~/shared/actions/prices";
import * as server from "~/shared/api/server";

export function loadSlPrices(lo?: boolean) {
	return (dispatch) => {
		dispatch(actions.getSlPricesRequest());
		return server.getSlPrices(lo).then((result) => dispatch(actions.getSlPricesResponse(result)));
	};
}

export function loadPkbPrices(lo: boolean) {
	return (dispatch) => {
		dispatch(actions.getPkbPricesRequest());
		return server.getPkbPrices(lo).then((result) => dispatch(actions.getPkbPricesResponse(result)));
	};
}

export function loadPolicyPrices(policyNumber, productId?) {
	return (dispatch) => {
		dispatch(actions.getPolicyPricesRequest(policyNumber));
		return server.getPolicyPrices(policyNumber).then(async (result) => {
			let regular: Promise<any> | undefined;
			if (productId === "76") {
				regular = await server.getRegularSlPrices();
			}
			dispatch(
				actions.getPolicyPricesResponse({
					policyNumber,
					result,
					regular,
				}),
			);
		});
	};
}

export function loadFundPrices(policyNumber) {
	return (dispatch) => {
		dispatch(actions.getFundPricesRequest(policyNumber));
		return server.getFundPrices(policyNumber).then((result) => dispatch(actions.getFundPricesResponse({ policyNumber, result })));
	};
}
